import { useEffect, useState } from 'react'

/** True while the element with this id overlaps the viewport. */
export function useElementInView(id: string, rootMargin = '0px'): boolean {
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const element = document.getElementById(id)
    if (!element || typeof IntersectionObserver === 'undefined') return
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { rootMargin })
    observer.observe(element)
    return () => observer.disconnect()
  }, [id, rootMargin])

  return inView
}
